import { TYPES } from "./types";
import { tkt1TrustedPersonService } from "../services"; 

export const getTKT1TrustedPersonInfos = (query) => async (dispatch) => {
  try {
    const result = await tkt1TrustedPersonService.getTrustedPersonInfos(query);
    const data = result.data.data;
    
    if (data) {
      dispatch({
        type: TYPES.ACTION_GET_TKT1_TRUSTED_PERSON_INFOS_SUCCESS,
        payload: {data},
      });
    } else {
      dispatch({
        type: TYPES.ACTION_GET_TKT1_TRUSTED_PERSON_INFOS_FAIL,
        payload: {},
      });
    }
  } catch (error) {
    dispatch({
      type: TYPES.ACTION_CALL_API_FAIL,
      payload: {
        message: error,
      },
    });
  }
};

export const getTKT1TrustedPersonInfoByID = (id) => async (dispatch) => {
  try {
    const result = await tkt1TrustedPersonService.getTrustedPersonInfoByID(id);
    const data = result.data.data;
    
    if (data) {
      dispatch({
        type: TYPES.ACTION_GET_TKT1_TRUSTED_PERSON_INFO_BY_ID_SUCCESS,
        payload: {data},
      });
    } else {
      dispatch({
        type: TYPES.ACTION_GET_TKT1_TRUSTED_PERSON_INFO_BY_ID_FAIL,
        payload: {},
      });
    }
  } catch (error) {
    dispatch({
      type: TYPES.ACTION_CALL_API_FAIL,
      payload: {
        message: error,
      },
    });
  }
};

export const getTKT1TrustedPersonInfoByMID = (mid) => async (dispatch) => {
  try {
    const result = await tkt1TrustedPersonService.getTrustedPersonInfoByMID(mid);
    const data = result.data.data;
    
    if (data) {
      dispatch({
        type: TYPES.ACTION_GET_TKT1_TRUSTED_PERSON_INFO_BY_MID_SUCCESS,
        payload: {data},
      });
    } else {
      dispatch({
        type: TYPES.ACTION_GET_TKT1_TRUSTED_PERSON_INFO_BY_MID_FAIL,
        payload: {},
      });
    }
  } catch (error) {
    dispatch({
      type: TYPES.ACTION_CALL_API_FAIL,
      payload: {
        message: error,
      },
    });
  }
};

export const createTKT1TrustedPersonInfo = (trustedPersonInfoData) => async (dispatch) => {
  try {
    const result = await tkt1TrustedPersonService.createTrustedPersonInfo(trustedPersonInfoData);
    const data = result.data.data;
    
    if (data) {
      dispatch({
        type: TYPES.ACTION_CREATE_TKT1_TRUSTED_PERSON_INFO_SUCCESS,
        payload: {data},
      });
    } else {
      dispatch({
        type: TYPES.ACTION_CREATE_TKT1_TRUSTED_PERSON_INFO_FAIL,
        payload: {},
      });
    }
  } catch (error) {
    dispatch({
      type: TYPES.ACTION_CALL_API_FAIL,
      payload: {
        message: error,
      },
    });
  }
};

export const updateTKT1TrustedPersonInfo = (id, trustedPersonInfoData) => async (dispatch) => {
  try {
    const result = await tkt1TrustedPersonService.updateTrustedPersonInfo(id, trustedPersonInfoData);
    const data = result.data.data;
    
    if (data) {
      dispatch({
        type: TYPES.ACTION_UPDATE_TKT1_TRUSTED_PERSON_INFO_SUCCESS,
        payload: {data},
      });
    } else {
      dispatch({
        type: TYPES.ACTION_UPDATE_TKT1_TRUSTED_PERSON_INFO_FAIL,
        payload: {},
      });
    }
  } catch (error) {
    dispatch({
      type: TYPES.ACTION_CALL_API_FAIL,
      payload: {
        message: error,
      },
    });
  }
};

export const deleteTKT1TrustedPersonInfo = (id) => async (dispatch) => {
  try {
    const result = await tkt1TrustedPersonService.deleteTrustedPersonInfo(id);
    
    if (result.data.success) {
      dispatch({
        type: TYPES.ACTION_DELETE_TKT1_TRUSTED_PERSON_INFO_SUCCESS,
        payload: {id},
      });
    } else {
      dispatch({
        type: TYPES.ACTION_DELETE_TKT1_TRUSTED_PERSON_INFO_FAIL,
        payload: {},
      });
    }
  } catch (error) {
    dispatch({
      type: TYPES.ACTION_CALL_API_FAIL,
      payload: {
        message: error,
      },
    });
  }
};

export const tkt1TrustedPersonAction = {
  getTKT1TrustedPersonInfos,
  getTKT1TrustedPersonInfoByID,
  getTKT1TrustedPersonInfoByMID,
  createTKT1TrustedPersonInfo,
  updateTKT1TrustedPersonInfo,
  deleteTKT1TrustedPersonInfo
};